import { createFileRoute } from '@tanstack/react-router';

import { ExportPage } from '@/features/logbook';

export const Route = createFileRoute('/logbook/export')({
  component: ExportPage,
});
